import { ITechnicalCategoryHook } from '@models';
import { useStore } from '@stores';
import { debounce } from 'lodash';
import { useEffect, useState } from 'react';

interface IProps {
  vin: string;
}

export const useTechnicalCategories = ({ vin }: IProps): ITechnicalCategoryHook => {
  const { technicalCategoryStore } = useStore();
  const { pagedCategories } = technicalCategoryStore;
  const [name, setName] = useState<string>('');

  useEffect(() => {
    name &&
      technicalCategoryStore.getAllCategories({
        vin,
        name,
        skipCount: 0,
        maxResultCount: 10,
      });
  }, [technicalCategoryStore, vin, name]);

  const handleNameSearch = debounce((text: string) => {
    if (!text) technicalCategoryStore.clearPagedCategories();
    setName(text);
  }, 500);

  return {
    categories: pagedCategories.items,
    totalCount: pagedCategories.totalCount,
    handleNameSearch,
    name,
    setName,
  };
};
